module.exports = __webpack_public_path__ + "images/emoji/womans_hat.934ff33da65e0f3a620b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/womans_hat.png
// module id = toU7
// module chunks = 2